module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notFound"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "notFound-content f24"
  }, [_vm._v("Error，页面出错啦！！   请点击返回首页或者返回上一页面~")]), _vm._v(" "), _c('div', {
    staticClass: "notFound-btn"
  }, [_c('a'), _vm._v(" "), _c('a', {
    staticClass: "notFound-link",
    attrs: {
      "href": "/"
    }
  }, [_c('el-button', {
    staticClass: "notFound-button",
    attrs: {
      "round": ""
    }
  }, [_vm._v("返回首页")])], 1), _vm._v(" "), _c('a', {
    staticClass: "notFound-link",
    on: {
      "click": _vm.goPrev
    }
  }, [_c('el-button', {
    staticClass: "notFound-button",
    attrs: {
      "round": ""
    }
  }, [_vm._v("返回上一页")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notFound-img"
  }, [_c('img', {
    staticClass: "notFound-img-detail",
    attrs: {
      "src": require("../../assets/img/notFound/404.png"),
      "alt": "404 not Found"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-faf96906"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/notFound.vue
// module id = 684
// module chunks = 12